export const getYears = () => {
    const goBackYears = 100
    const currentYear = new Date().getFullYear()
    const startYear = currentYear - goBackYears
    return [...Array(goBackYears + 1).keys()].map(x => x + startYear)
}

export const getDays = (year: number, month: number) => {
    const maxDate = getFinalDate(year, month)
    return [...Array(maxDate).keys()].map(x => x + 1)
}

export const getFinalDate = (year: number, month: number) => {
    return new Date(year, month, 0).getDate()
}

export const validateDate = (year: number, month: number, day: number) => {
    const date = new Date(year, month - 1, day)
    if (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    ) {
      return true
    }
    return false
  }

export const truncateDate = (date: Date): Date => {
  if (date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  return date;
}

export const DaysOfWeek = {
  SUN: 0,
  MON: 1,
  TUE: 2,
  WED: 3,
  THU: 4,
  FRI: 5,
  SAT: 6
}